module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-left-b0cae333d76d21068c2e9f9d2ef03360.svg";